import * as React from 'react'

const TableEmptyMessage = () => <p className="securities-report-indicators__no-data">データ無し</p>

export default TableEmptyMessage
